import { IconName } from 'components/Icon/IconName';

import {
  TakeActionDropdownResourcesItemData,
  TakeActionDropdownSearchItemData,
} from './types/TakeActionDropdownData';

export const takeActionDropdownDataBySearchItemType: Record<
  TakeActionDropdownSearchItemData['type'],
  { iconName: IconName; qaId: string; trackClickedName: string }
> = {
  volop: {
    iconName: 'hand',
    qaId: 'nav-volop-link',
    trackClickedName: 'Volunteer',
  },
  event: {
    iconName: 'star-calendar',
    qaId: 'nav-event-link',
    trackClickedName: 'Attend an Event',
  },
  donations: {
    iconName: 'money',
    qaId: 'nav-donations-link',
    trackClickedName: 'Give Donations',
  },
  petitions: {
    iconName: 'group',
    qaId: 'nav-petitions-link',
    trackClickedName: 'Sign Petitions',
  },
  loans: {
    iconName: 'loan',
    qaId: 'nav-loans-link',
    trackClickedName: 'Make a Loan',
  },
};

export const takeActionDropdownDataByResourcesItemType: Record<
  TakeActionDropdownResourcesItemData['type'],
  { image: string; qaId: string; trackClickedName: string }
> = {
  'idealist-movement': {
    image: 'illustrations/announce-illustration.svg',
    qaId: 'nav-idealist-movement-link',
    trackClickedName: 'Idealist Movement',
  },
  'knowledge-base': {
    image: 'illustrations/article-illustration.svg',
    qaId: 'nav-knowledge-base-link',
    trackClickedName: 'Knowledge Base',
  },
};
